'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to track whether the component has been hydrated on the client side.
 * This is useful for preventing hydration errors where there are
 * content mismatches between server and client rendering.
 *
 * @returns {boolean} Returns a state variable that is true after the component
 * has been hydrated on the client
 */
export function useIsHydrated(): boolean {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (!isHydrated) {
      setIsHydrated(true);
    }
    // This effect runs only once when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isHydrated;
}
